module.exports = __webpack_public_path__ + "img/orange_026.c213a483.png";